<template>
    <component :is="{template: '<span class=\'text-muted\'>' + content + '</span>'}"></component>
</template>

<script>
    import store from '@/store'

    export default {
        props: ['logLine'],

        data() {
            return {
                shared: store
            }
        },

        computed: {
            baseUrl() {
                return '/' + this.logLine.log_subject_type + '/' + this.logLine.log_subject_id
            },

            content() {
                if (this.logLine.event === 'company-created') {
                    return '<router-link to="' + this.baseUrl + '">' + this.logLine.subject.name + '</router-link> was created.'
                }

                if (this.logLine.event === 'company-updated') {
                    return '<router-link to="' + this.baseUrl + '">' + this.logLine.subject.name + '</router-link> was updated.'
                }

                if (this.logLine.event === 'person-created') {
                    return '<router-link to="' + this.baseUrl + '">' + this.logLine.subject.name + '</router-link> was created.'
                }

                if (this.logLine.event === 'person-updated') {
                    return '<router-link to="' + this.baseUrl + '">' + this.logLine.subject.name + '</router-link> was updated.'
                }

                if (this.logLine.event === 'invoice-created') {
                    return '<router-link to="' + this.baseUrl + '/invoices/' + this.logLine.subject_id + '">Invoice #' + this.logLine.subject_id + '</router-link> was created.'
                }

                if (this.logLine.event === 'invoice-drafted') {
                    return '<router-link to="' + this.baseUrl + '/invoices/' + this.logLine.subject_id + '">Invoice #' + this.logLine.subject_id + '</router-link> was drafted.'
                }

                if (this.logLine.event === 'invoice-paid') {
                    return '<router-link to="' + this.baseUrl + '/invoices/' + this.logLine.subject_id + '">Invoice #' + this.logLine.subject_id + '</router-link> was paid.'
                }

                if (this.logLine.event === 'subscription-created') {
                    return '<router-link to="' + this.baseUrl + '/subscriptions/' + this.logLine.subject_id + '">Subscription #' + this.logLine.subject_id + '</router-link> was created.'
                }

                if (this.logLine.event === 'subscription-updated') {
                    return '<router-link to="' + this.baseUrl + '/subscriptions/' + this.logLine.subject_id + '">#' + this.logLine.subject_id + '</router-link> was updated.'
                }

                if (this.logLine.event === 'order-created') {
                    return '<router-link to="' + this.baseUrl + '/orders/' + this.logLine.subject_id + '">Order HG' + this.logLine.subject_id + '</router-link> was created.'
                }

                if (this.logLine.event === 'order-updated') {
                    return '<router-link to="' + this.baseUrl + '/orders/' + this.logLine.subject_id + '">Order HG' + this.logLine.subject_id + '</router-link> was updated.'
                }

                if (this.logLine.event === 'order-confirmation-created') {
                    return '<a href="/api/v1/order-confirmations/' + this.logLine.subject_id + '?token=' + this.shared.token + '">Order Confirmation #' + this.logLine.subject_id + '</a> was created.'
                }

                if (this.logLine.event === 'opportunity-created') {
                    return '<router-link to="' + this.baseUrl + '/opportunities/' + this.logLine.subject_id + '">Opportunity #' + this.logLine.subject_id + '</router-link> was created.'
                }

                if (this.logLine.event === 'opportunity-updated') {
                    return '<router-link to="' + this.baseUrl + '/opportunities/' + this.logLine.subject_id + '">Opportunity #' + this.logLine.subject_id + '</router-link> was updated.'
                }

                if (this.logLine.event === 'opportunity-closed') {
                    return '<router-link to="' + this.baseUrl + '/opportunities/' + this.logLine.subject_id + '">Opportunity #' + this.logLine.subject_id + '</router-link> was closed.'
                }

                if (this.logLine.event === 'opportunity-converted-to-order') {
                    return '<router-link to="' + this.baseUrl + '/opportunities/' + this.logLine.subject_id + '">Opportunity #' + this.logLine.subject_id + '</router-link> was converted to <router-link to="orders/' + this.logLine.parameters.order_id + '">order HG' + this.logLine.parameters.order_id + '</router-link>.'
                }

                if (this.logLine.event === 'opportunity-converted-to-subscription') {
                    return '<router-link to="' + this.baseUrl + '/opportunities/' + this.logLine.subject_id + '">Opportunity #' + this.logLine.subject_id + '</router-link> was converted to <router-link to="subscriptions/' + this.logLine.parameters.subscription_id + '">subscription #' + this.logLine.parameters.subscription_id + '</router-link>.'
                }

                if (this.logLine.event === 'email-created') {
                    return '<router-link to="' + this.baseUrl + '/emails">An email</router-link> was received.'
                }

                if (this.logLine.event === 'comment-created' || this.logLine.event === 'reminder-created') {
                    return '<span style="white-space: pre-wrap;">' + this.logLine.subject.text + '</span>'
                }
            }
        }
    }
</script>
